import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Link } from "react-router-dom";
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Icon from 'material-ui/Icon';
import Button from 'material-ui/Button';
import ButtonBase from "material-ui/ButtonBase";
import { withStyles } from 'material-ui/styles';
import styles from './styles';

import {
  softwareUpdateStop
} from '../../redux/actions';

class SoftwareVersionBar extends React.Component {

  render() {
    const {
      classes,
      translate,
      softwareUpdate,
      stopSoftwareUpdate,
      softwareVersion,
      impersonating
    } = this.props;

    var deviceLink = '/devices';
    var deviceVersion = '';
    var deviceType = '';
    var margintop = '0px';

    if (impersonating) {
      margintop = '60px';
    }

    if (softwareVersion && softwareUpdate) {
      if (!softwareVersion.isMultipleDevices) {
        deviceLink = '/device/' + softwareVersion.deviceId;
      }

      deviceVersion = softwareVersion.version;
      deviceType = softwareVersion.deviceType;
    }

    return (
      (softwareUpdate) ? (
        <AppBar position="fixed" style={{ background: '#005795', marginTop: margintop }} id="software-version-banner">
          <div className={classes.centred}>
            <Toolbar>
              <Typography type="title" className={classes.flex} color="inherit">
                {deviceVersion} {translate("software_version_available1")} {deviceType} {translate("software_version_available2")}
              </Typography>
              <ButtonBase
              className={classes.buttonBase}
              component={Link}
              to={deviceLink}
              >
                <Button className={classes.button} color="accent" raised mini>
                  {translate("general_devices")}
                </Button>
              </ButtonBase>
              <Button aria-label="Close" className={classes.button} fab mini onClick={() => stopSoftwareUpdate()}>
                <Icon>close</Icon>
              </Button>
            </Toolbar>
          </div>
        </AppBar>
      ) : (
          null
        )
    )
  }
}

const mapStateToProps = (state) => ({
  softwareUpdate: state.userReducer.softwareUpdate,
  softwareVersion: state.userReducer.softwareVersion,
  impersonating: state.userReducer.impersonating,
  ...state,
})

const mapDispatchToProps = (dispatch, props) => ({
  stopSoftwareUpdate: () => {
    dispatch(softwareUpdateStop());
  }
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(SoftwareVersionBar);
